var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiscovery(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18.27 18.27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,15.88a2.33,2.33,0,0,1,.14-.47,3.4,3.4,0,0,1,.5-.77c.84-.88,1.7-1.73,2.57-2.58a.28.28,0,0,1,.21-.1l2.22-.19a.31.31,0,0,0,.16-.06l1.12-1.12a6.43,6.43,0,1,1,.76.76L6.56,12.47a.35.35,0,0,0-.06.18l-.18,2.2a.34.34,0,0,1-.09.2L3.62,17.67a2.1,2.1,0,0,1-1.15.57s-.05,0-.08,0H1.86l-.08,0A2.07,2.07,0,0,1,.27,17.16,5.13,5.13,0,0,1,0,16.38ZM11.84,11.8A5.37,5.37,0,1,0,6.48,6.42,5.36,5.36,0,0,0,11.84,11.8ZM3.1,13.72c-.59.58-1.21,1.16-1.79,1.77a1.18,1.18,0,0,0-.23.6,1,1,0,0,0,.6,1,1,1,0,0,0,1.17-.19c.42-.39.82-.81,1.23-1.21l.51-.5Zm2.19.58.12-1.44L4,13Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.31,8.1V6.33H11v.2c0,.5,0,1,0,1.52A1.1,1.1,0,0,1,9.85,9.17h-.5a.95.95,0,0,1,0-1.89c.18,0,.37,0,.57,0V3.38h4.47v.2c0,1.73,0,3.46,0,5.19A1.14,1.14,0,0,1,13.16,10h-.39a.95.95,0,0,1,0-1.89Zm0-3.65H11v.79h2.3Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscovery);
export default __webpack_public_path__ + "static/media/discovery.599e19905272edd1b31ac91a2c499f2c.svg";
export { ForwardRef as ReactComponent };